
import api from "@/api/index"; //ABP API接口
import { Vue, Component, Ref } from "vue-property-decorator";
import { ElementTableView } from "@/lib/ElementTableView";
import QrcodeVue from 'qrcode.vue'

import { MessageBox } from "element-ui";
import enumFilter from "@/mixins/filters/enums";

import { ActivityDto } from "@/api/appService";

@Component({
  name: "ActivityList",
  mixins: [enumFilter],
  components:{
    QrcodeVue
  }
})
export default class ActivityList extends ElementTableView {
  tableItems: ActivityDto[] = [];

  async created() {
    await this.fetchData();
  }

  queryForm: any = {
    filterType: "0",
    title: "",
    isActive: undefined,
    from: undefined,
    to: undefined
  };

  currentRow?:ActivityDto;

  // 获取表数据
  async fetchData() {
    this.table.listLoading = true;
    await api.activity
      .getAll({
        filterType: this.queryForm.filterType,
        title: this.queryForm.title,
        isActive: this.queryForm.isActive,
        from: this.queryForm.from,
        to: this.queryForm.to,
        sorting: this.table.sorting,
        skipCount: this.skipCount,
        maxResultCount: this.table.pagesize
      })
      .then(res => {
        console.log(res);
        this.table.listLoading = false;
        this.tableItems = res.items!;
        this.table.totalCount = res.totalCount!;
      });
  }

  // 新建
  handleCreate() {
    this.$router.push({
      path: `/activity/create/0`
    });
  }

  // 编辑
  handleEdit(index: number, row: ActivityDto) {
    this.$router.push({
      path: `/activity/create/${row.id}`
    });
  }

  // 删除
  async handleDelete(index: number, row: ActivityDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.activity.delete({ id: row.id }).then(res => {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.fetchData();
      });
    });
  }

  // 更新当前页
  async current_change(e: number) {
    this.table.page = e;
    await this.fetchData();
  }

  // Table排序
  async sort(e: any) {
    console.log("sort : ", e);
    if (e.prop && e.order) {
      this.table.sorting = `${e.prop} ${e.order}`;
    }
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    this.table.pagesize = e;
    await this.fetchData();
  }

  // 搜索
  async handleSearch() {
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      title: "",
      from: undefined,
      to: undefined,
      isActive: undefined
    };
    await this.fetchData();
  }

  async handelOnSaved() {
    await this.fetchData();
  }

  handleViewApply($index: number, row: ActivityDto) {
    this.$router.push({
      path: `/activity/applyList/${row.id}`
    });
  }

  qrShow = false;
  qrPath = "";
  qrTitle = "";
  qrType = "";

  qrUrlOfStandard = '';
  qrShowOfStandard = false;

  GetQr($index: number, row: ActivityDto) {
    api.client
      .getUnLimitQr({
        scene: `QD:Activity:${row.id}`
      })
      .then(res => {
        console.log(res);
        this.qrShow = true;
        this.qrPath = res;
        this.qrTitle = row.title!;
        this.qrType = "活动小程序码";
      });
  }
  getQrByStandard(row:ActivityDto){
    this.qrUrlOfStandard = 'https://tongmeng.gongyila.com/activity/checkIn?id='+row.id;
    this.qrShowOfStandard = true;
  }

  changeStatus($index: number, row: ActivityDto) {
    api.activity.changeStatus({ id: row.id }).then(res => {
      this.$message({
        type: "success",
        message: "操作成功"
      });
      this.fetchData();
    });
  }

  handleMenu(e: any) {
    console.log(e);
    this.currentRow = e.item;
    switch (e.type) {
      case "edit": {
        this.handleEdit(0, e.item);
        return;
      }
      case "viewApply": {
        this.handleViewApply(0, e.item);
        return;
      }
      case "getQr": {
        this.GetQr(0, e.item);
        return;
      }
      case 'getQrByStandard':
        this.getQrByStandard(e.item);
        return;
      case "changeStatus": {
        this.changeStatus(0, e.item);
        return;
      }
      case "delete": {
        this.handleDelete(0, e.item);
        return;
      }
    }
  }

  handelStatusChange(e: any) {
    this.table = Object.assign({}, this.table, {
      page: 1
    });
    this.fetchData();
  }
}
